<template>
  <div class="tumeng-line-container" :style="wrapStyle">
    <canvas ref="lineCanvas" :width="conf.width" :height="conf.height"></canvas>
  </div>
</template>

<script>
export default {
  name: "TumengLine",
  components: {},
  props: {
    conf: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    wrapStyle() {
      return {
        width: this.conf.width,
        height: this.conf.height,
        background: this.conf.bgColor,
      };
    },
  },
  watch: {
    conf: {
      handler(val) {
        this.drawLineFun();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    drawLineFun() {
      console.log("开始绘line啦");
      const canvas = this.$refs.lineCanvas;
      if (!canvas) return;

      // console.log(canvas.width,canvas.height)
      const confWidth = this.conf.width;
      const confHeight = this.conf.height;

      if (canvas.getContext) {
        const ctx = canvas.getContext("2d");
        // 清空之前的绘图
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        this.$nextTick(() => {
          // 设置线条颜色和宽度
          ctx.strokeStyle = this.conf.fontColor; // 黑色线条
          ctx.lineWidth = this.conf.lineWidth; // 线条宽度

          if (this.conf.lineType == 1){
            ctx.beginPath();
            ctx.moveTo(0, confHeight/2); // 起点
            ctx.lineTo(confWidth, confHeight/2); // 终点
            ctx.stroke(); // 绘制线条
          }
          if (this.conf.lineType == 2){
            ctx.beginPath();
            ctx.moveTo(confWidth/2, 0); // 起点
            ctx.lineTo(confWidth/2, confHeight); // 终点
            ctx.stroke(); // 绘制线条
          }

          // 绘制第一条对角线（右上-左下）
          if (this.conf.lineType == 3 || this.conf.lineType == 5) {
            ctx.beginPath();
            ctx.moveTo(0, confHeight); // 起点
            ctx.lineTo(confWidth, 0); // 终点
            ctx.stroke(); // 绘制线条
          }

          // 绘制第二条对角线（左上-右下）
          if (this.conf.lineType == 4 || this.conf.lineType == 5) {
            ctx.beginPath();
            ctx.moveTo(0, 0); // 起点
            ctx.lineTo(confWidth, confHeight); // 终点
            ctx.stroke(); // 绘制线条
          }
        });
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.drawLineFun();
    }, 1000);
  },
};
</script>

<style lang="scss" scoped>
.tumeng-line-container {
  width: 100%;
  height: 100%;
  > img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
